<template>
  <div :class="{'row': label!=null}">
    <a :id="'anker_'+ veldID"></a>
    <div v-if="headerText!=''" class="col-md-12">
      <div class="metaHeader">{{headerText}}</div>
    </div>
    <div class="col-md-4" v-if="label!==null">
      <span
        class="pull-right"
        v-if="helptext!==null && helptext!=='' && helptext!==' ' && helptext!=='&nbsp;'"
      >
        <XVhelpcontrol :helptext="helptext"></XVhelpcontrol>
      </span>
      <label>
        <span>{{label}}</span>
        <span v-if="required">
          <font-awesome-icon :icon="['fal', 'asterisk']" size="xs" />
        </span>
      </label>
    </div>
    <div :class="{'col-md-8': label!=null}">
      <div :class="{'form-group has-feedback': label!=null,'has-error': haserror}">
        <slot></slot>
        <span v-show="haserror" style="color:Red">{{ errormessage }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { FAMixin } from 'pevueglobal'
export default {
  mixins: [FAMixin],
  props: {
    helptext: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    error: {
      type: String,
      required: false
    },
    haserror: {
      type: Boolean,
      default: false
    },
    errormessage: {
      type: String,
      default: ''
    },
    headerText: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    veldID: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {}
  }
}
</script>


